module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/touchspin-v2/touchspin-v2.component.scss
// module id = ./src/app/components/tools/touchspin-v2/touchspin-v2.component.scss
// module chunks = main